import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { MatomoTracker } from 'ngx-matomo';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { LayoutComponent } from 'src/app/layout/layout.component';

@Component({
  selector: 'app-wmsm-excludevendor',
  templateUrl: './wmsm-excludevendor.component.html',
  styleUrls: ['./wmsm-excludevendor.component.scss']
})
export class WmsmExcludevendorComponent extends BaseComponent implements OnInit {
  loading: boolean = false;
  validateForm: FormGroup;
  SiteList: any;
  pageIndex: number = 1;
  pageSize: number = 20;
  nzTotal: number = 0;
  listOfData: any[] = [];
  editData: any;
  isEdit: boolean = false;
  fileList: NzUploadFile[] = [];
  VendorName: any;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];

  constructor(private fb: FormBuilder,
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private AuthService: AuthService,
    private translate: TranslateService,
    private LayoutComponent: LayoutComponent,
    private http: HttpClient) { super() }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      Site: ['', [Validators.required]],
      VendorCode: [],
    });
    this.LayoutComponent.geturl()
    this.GetSiteCondition();
    this.matomotracker.trackPageView("系統管理員權限設置")
    this.matomotracker.trackEvent("系統管理員權限設置", "供應商排除名單", "view", 1);
  }

  GetSiteCondition(): void {
    this.loading = true;
    const params = '';
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSiteCondition.url}`;
    this.webApiService.doGet(url, params).subscribe(
      (res) => {
        if (res) {
          this.SiteList = res;
          //this.validateForm.controls['Site'].setValue(res[0]);
        } else {
          this.messageService.error(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
        this.loading = false;
      }
    );
  }

  onSearch() {
    this.pageIndex = 1;
    this.getResultData([]);
  }

  getResultData(arr) {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.QueryExcludeVendor.url}`;
    var params;
    if (arr.length == 0) {
      params = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        data: {
          SiteNo: this.validateForm.controls['Site'].value,
          VendorCode: [this.validateForm.controls['VendorCode'].value]
        },
      };
    } else {
      params = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        data: {
          SiteNo: this.validateForm.controls['Site'].value,
          VendorCode: arr
        },
      };
    }

    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.listOfData = res.data.map((item) => {
            return item;
          });
          this.nzTotal = res.total;
          this.messageService.success(res.msg);
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.messageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
        this.loading = false;
      }
    );
  }

  // 切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData([]);
  }

  // 切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData([]);
  }

  onEdit(data) {
    this.editData = { ...data };
    this.isEdit = true;
  }

  saveEdit(event) {
    this.editData = null;
    this.modifyData(
      `${this.Environment.authConfig.wmsmUrl}${URLConst.EditExcludeVendor.url}`,
      event
    );
  }

  modifyData(url, data) {
    this.loading = true;
    const params = {
      data: {
        Lock: data.Lock,
        Site: data.Site,
        VendorCode: data.VendorCode,
        VendorName: data.VendorName,
        ExcludeVendorReason: data.ExcludeVendorReason,
      },
    };
    this.webApiService.doPost(url, params).subscribe((res) => {
      if (res && res.status == this.Environment.authConfig.wmsmStatus) {
        this.messageService.success(res.msg);
        setTimeout(() => {
          this.getResultData([data.VendorCode]);
        }, 200);
        this.isEdit = false;
      } else {
        this.messageService.error(res.msg);
      }
      this.loading = false;
    });
  }

  closeEdit() {
    this.isEdit = false;
  }

  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownLoadExcludeVendorExcel.url}`;
    const params = {
      data: {
        SiteNo: this.validateForm.controls['Site'].value,
        VendorCode: [this.validateForm.controls['VendorCode'].value]
      },
    };
    this.webApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `Exclude_Vendor_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }

  exportSampleTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownLoadExcludeVendorSampleExcel.url}`;
    const params = {
      data: {

      },
    };
    this.webApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `Exclude_Vendor_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.saveExcelData(file);
    return false;
  };

  saveExcelData(file) {
    this.loading = true;
    if (!this.ExcelControl.includes(file.type)) {
      this.messageService.warning(
        this.translate.instant('Prompt.MustUploadExcelFile')
      );
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('site', this.validateForm.controls['Site'].value);
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpLoadExcludeVendorExcel.url}`;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          if (res['body'].status == this.Environment.authConfig.wmsmStatus) {
            this.getResultData(res['body'].data);
            this.messageService.success(res['body'].msg);
          } else {
            this.messageService.warning(res['body'].msg);
          }
          this.loading = false;
        },
        (error) => {
          this.messageService.error('upload failed.');
          this.loading = false;
        }
      );
  }
  GetFileTokenOnClick(data) {
    this.webApiService.downloadFileByToken(data.proofFile).subscribe(
      (res) => {
        this.downloadFile8(res, data.vendorCode);
        this.messageService.success(res.msg);

      },
      (error) => {
        this.messageService.error(error.msg);
      }
    );
  }


}
